import {
  BiCalendarEvent,
  BiCube,
  BiBook,
  BiAward,
  BiCalculator,
  BiUser,
  BiGroup,
  BiHome,
  BiCog,
  BiBell,
  BiDownload,
  BiUpload,
  BiEdit,
  BiTrash,
  BiPlus,
  BiCheck,
  BiX,
  BiInfoCircle,
  BiTrendingUp,
  BiBarChart,
  BiListUl,
  BiSearch,
  BiFilter,
  BiSort,
  BiRefresh,
  BiSave,
  BiPrinter,
  BiShare,
  BiLock,
  BiShow,
  BiHide,
  BiHeart,
  BiTime,
  BiPhone,
  BiEnvelope,
  BiArchive,
  BiHash,
  BiPalette,
  BiLayer,
  BiArrowToRight,
  BiArrowToTop,
  BiArrowToBottom,
  BiChild,
  BiBookOpen,
  BiGlasses,
  BiHelpCircle,
  BiChat,
  BiSend,
  BiLogOut,
  BiArrowBack,
  BiChalkboard,
  BiShield,
  BiWifiOff,
  BiWifi1,
  BiWifi2,
  BiMapPin,
  BiMenu,
  BiChevronLeft,
  BiChevronUp,
  BiHistory,
  BiChevronRight,
  BiChevronDown,
  BiError,
  BiLeaf,
  BiUndo,
  BiSortUp,
  BiSortDown,
  BiDetail,
  BiBroadcast,
  BiDesktop,
  BiMobile,
  BiPlay,
} from "react-icons/bi";
import { LuGraduationCap, LuKeyboard } from "react-icons/lu";
import { RiLoginBoxLine, RiExternalLinkLine } from "react-icons/ri";
import { PiFootprintsDuotone, PiStepsBold } from "react-icons/pi";
import { FaFileExcel } from "react-icons/fa";
import { useMemo } from "react";

export const useIcons = () => {
  const main = useMemo(
    () => ({
      session: BiCalendarEvent,
      term: BiCube,
      level: BiLayer,
      class: BiBook,
      subject: BiAward,
      grade: BiCalculator,
      assessment: BiTrendingUp,
      result: BiBarChart,
      academic: BiBookOpen,
      school: BiLeaf,
      promotion: LuGraduationCap,
      home: BiHome,
      dashboard: BiBarChart,
      notifications: BiBell,
      audit: BiDetail,
    }),
    []
  );

  const people = useMemo(
    () => ({
      student: BiChild,
      students: BiGroup,
      teacher: BiUser,
      admin: BiUser,
      guardian: BiHeart,
      parent: BiUser,
      principal: BiUser,
      headTeacher: BiUser,
      formTeacher: BiUser,
      user: BiUser,
      users: BiGroup,
    }),
    []
  );

  const utility = useMemo(
    () => ({
      footprints: PiFootprintsDuotone,
      steps: PiStepsBold,
      score: BiHash,
      chalkboard: BiChalkboard,
      search: BiSearch,
      filter: BiFilter,
      login: RiLoginBoxLine,
      logout: BiLogOut,
      plus: BiPlus,
      edit: BiEdit,
      delete: BiTrash,
      save: BiSave,
      cancel: BiX,
      check: BiCheck,
      download: BiDownload,
      upload: BiUpload,
      print: BiPrinter,
      share: BiShare,
      refresh: BiRefresh,
      view: BiShow,
      hide: BiHide,
      bulk: BiListUl,
      review: BiGlasses,
      help: BiHelpCircle,
      sort: BiSort,
      sortUp: BiSortUp,
      sortDown: BiSortDown,
      color: BiPalette,
      shield: BiShield,
      history: BiHistory,
      externalLink: RiExternalLinkLine,
      info: BiInfoCircle,
      locked: BiLock,
      heart: BiHeart,
      clock: BiTime,
      archive: BiArchive,
      settings: BiCog,
      menu: BiListUl,
      error: BiError,
      arrowLeft: BiArrowBack,
      arrowRight: BiArrowToRight,
      arrowUp: BiArrowToTop,
      arrowDown: BiArrowToBottom,
      chevronLeft: BiChevronLeft,
      chevronRight: BiChevronRight,
      chevronUp: BiChevronUp,
      chevronDown: BiChevronDown,
      hamburger: BiMenu,
      email: BiEnvelope,
      phone: BiPhone,
      send: BiSend,
      mapPin: BiMapPin,
      notification: BiBell,
      chat: BiChat,
      keyboard: LuKeyboard,
      award: BiAward,
      wifiOff: BiWifiOff,
      wifi1: BiWifi1,
      wifi2: BiWifi2,
      excelFile: FaFileExcel,
      undo: BiUndo,
      broadcast: BiBroadcast,
      mobile: BiMobile,
      desktop: BiDesktop,
      infoCircle: BiInfoCircle,
      play: BiPlay,
    }),
    []
  );

  return useMemo(
    () => ({
      main,
      people,
      utility,
    }),
    [main, people, utility]
  );
};

export default useIcons;
